import React, { useEffect, useState } from "react";
import {useDispatch, useSelector} from "react-redux";
import {Avatar, Divider, Popover, Typography} from "antd";
import {userSignOut} from "appRedux/actions/Auth";
import { useHistory } from "react-router";
import { CreditCardOutlined, PoweroffOutlined, ProfileOutlined, ScheduleOutlined, SolutionOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons';

const {Text} = Typography;

const UserInfo = () => {

  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector(({auth}) => auth.authUser);
  const widtInitial = useSelector(({common}) => common.width);
  const [widthScreen, setWidthScreen] = useState(widtInitial);

  useEffect(() => {
    const handleResize = () => setWidthScreen(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const userMenuOptions = (
    <div className="gx-user-popover">
      {widthScreen <= 480 ? (
        <div className="gx-user-popover-header" onClick={() => history.push("/account")}>
          <Text strong style={{ fontSize: "14px", color: "black" }}>{user ? user.fullname.toUpperCase() : ""}</Text>
          <Text type="secondary" style={{ fontSize: "12px" }}>Ver mi perfil</Text>
        </div>
      ) : null}
      <Divider><Text strong>Acceso Rapido</Text></Divider>
      <ul className="gx-user-popover-list">
        <li onClick={() => history.push("/bookings")}><ScheduleOutlined /> Reservas y certificados</li>
        <li onClick={() => history.push("/payments")}><CreditCardOutlined /> Pagos</li>
        <li onClick={() => history.push("/subaccounts")}><TeamOutlined /> Subcuentas</li>
        <li onClick={() => history.push("/prescriptions")}><ProfileOutlined /> Recetas</li>
        <li onClick={() => history.push("/history")}><SolutionOutlined /> Historia clinica</li>
      </ul>
      <Divider><Text strong>Cuenta</Text></Divider>
      <ul className="gx-user-popover-list">
        <li onClick={() => history.push("/account")}><UserOutlined /> Mi cuenta</li>
        <li onClick={() => dispatch(userSignOut())}><PoweroffOutlined /> Cerrar sesion</li>
      </ul>
    </div>
  );

  return (
    <Popover overlayClassName="gx-popover-horizantal" placement="bottomRight" content={userMenuOptions}
             trigger="click">
      <Avatar icon={<UserOutlined />}  src={`${user.photo}`}
              className="gx-avatar gx-pointer" alt=""/>
    </Popover>
  )

}

export default UserInfo;
